import React from "react";
import wrapComponentWithPopup, { PopupProps } from "../../../../../sharedComponents/wrapComponentWithPopup/wrapComponentWithPopup";
import WithPanelHeader from "../../../../../sharedComponents/WithPanelHeader";

type Props = PopupProps;

class DuplicateInvitationPopup extends React.PureComponent<Props, {}>  {
  render() {
    return (
      <WithPanelHeader title="Duplicate Invitation" hideControls>
        <div className="component--duplicate-invitation-popup">
          <div className="text">This email belongs to an existing team member.</div>
          <button onClick={this.props.closePopup}>Close</button>
        </div>
      </WithPanelHeader>
    );
  }
}

export default wrapComponentWithPopup(DuplicateInvitationPopup);
